/**
 * @generated SignedSource<<49577fbafcdd97f20032ea6aafeb97ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesSidePanel_allowedTabs_stream$data = {
  readonly askCopilotConversationExists: boolean;
  readonly claimedEvents: ReadonlyArray<{
    readonly attendees: ReadonlyArray<{
      readonly email: string;
    } | null>;
  }>;
  readonly isExternal: boolean;
  readonly noteWithRecordingExists: boolean;
  readonly notestreamusers: ReadonlyArray<{
    readonly user: {
      readonly email: string;
    };
  }>;
  readonly " $fragmentType": "SeriesSidePanel_allowedTabs_stream";
};
export type SeriesSidePanel_allowedTabs_stream$key = {
  readonly " $data"?: SeriesSidePanel_allowedTabs_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesSidePanel_allowedTabs_stream">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesSidePanel_allowedTabs_stream",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStreamUser",
      "kind": "LinkedField",
      "name": "notestreamusers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "claimedEvents",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Attendee",
          "kind": "LinkedField",
          "name": "attendees",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteWithRecordingExists",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "askCopilotConversationExists",
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "e7bf8549cd477f5a5acff2dabdc9b7e9";

export default node;
